import { render, staticRenderFns } from "./SuiviLivraisons.vue?vue&type=template&id=14c8ecd3"
import script from "./SuiviLivraisons.vue?vue&type=script&lang=js"
export * from "./SuiviLivraisons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports